import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

/*
  Generated class for the AuthStore provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ReserveStore {

  private _reserves:Array<Object>;
  set reserves(reserves:Array<Object>){
    this._reserves = reserves;
  }
  get reserves(){
    return this._reserves;
  }
}


// WEBPACK FOOTER //
// ./src/stores/reserve-store.ts